import { Component, OnInit, OnDestroy, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { AssigneeHelperService } from './trackeritem.browse.assignee.helper';
import { UserService } from '../../../../core/services/core.user.service';
import * as _ from 'lodash';

@Component({
  selector: 'tib-assignees',
  template: require('./trackeritem.browse.assignee.component.html'),
})
export class TibAssigneesComponent implements OnInit, OnDestroy {
  @Input() tracker: any;
  @Input() trackerItem: any;
  @Input() acls: any;
  @Output() change = new EventEmitter<any>();

  assigneeCount: Function;
  isAssignedTo: Function;
  isAssigned: Function;
  nobody: any;
  useFilter: boolean = false;
  searchTerm: string = '';
  assignees: any[] = [];
  itemIndex: number = -1;
  selectedElement: any;
  disabled: boolean;
  onAssign: any;
  onKeydown: any;
  private clickListener: (() => void) | null = null;

  constructor(
    private assigneeHelper: AssigneeHelperService, 
    private userService: UserService, 
    private el: ElementRef) {}

  ngOnInit() {
    this.nobody = this.userService.constants.nobody;
    this.assigneeCount = this.assigneeHelper.assigneeCount;
    this.isAssignedTo = this.assigneeHelper.isAssignedTo;
    this.isAssigned = this.assigneeHelper.isAssigned;

    this.disabled = (!this.acls?.canAssign) || this.trackerItem?.lockStatus || false;

    if (!this.disabled) {
      this.assignees = [this.nobody, ...(_.get(this.tracker, 'rel.assignees', []))];
      this.useFilter = this.assignees.length > 10;
      this.onAssign = this.assign;
      this.doSearch = _.debounce(this.doSearch, 250);

      this.clickListener = _.debounce(() => { this.focusInput(); }, 100);
      this.el.nativeElement.addEventListener('click', this.clickListener);
      this.onKeydown = this.handleKeydown;
    }
  }

  ngOnDestroy(): void {
    if (this.clickListener) {
      this.el.nativeElement.removeEventListener('click', this.clickListener);
      this.clickListener = null;
    }
  }

  doSearch() {
    this.itemIndex = -1;
    this.assigneeHelper.getFilteredAssignees(this.searchTerm, this.tracker.id)
      .then(this.updateAssigneeList, this.updateAssigneeList);
  }

  updateAssigneeList(list: any[]) {
    this.assignees = list;
    this.itemIndex = this.assignees.length > 1 ? 1 : 0;
    this.selectedElement = this.assignees[this.itemIndex];
  }

  assign($event, assignee: any) {
    $event.preventDefault();
    $event.stopPropagation();
    this.change.emit({ item: this.trackerItem, assignee: assignee });
  }

  closeDropdown() {
    this.el.nativeElement.querySelector('.dropdown').classList.remove('open');
  }

  focusInput() {
    const input = this.el.nativeElement.querySelector('input[type="text"]');
    if (input) {
      input.focus();
    }
  }

  assigneeTitle(trackerItem: any): string {
    return this.assigneeHelper.assigneeTitle(trackerItem);
  }

  handleKeydown(event: any) {
    if (!/(13|27|38|40|^9$)/.test(event.keyCode)) return;

    switch (event.keyCode) {
      case 13: // Enter
        this.onAssign(this.selectedElement);
        // Fall into the next case
      case 27: // Esc
        this.closeDropdown();
        break;

      case 40: // Down
      case 38: // Up
        if (!this.assignees.length) return;
        let index = this.itemIndex;

        if (event.keyCode === 38) index--; // Up
        if (event.keyCode === 40) index++; // Down

        if (index < 0) index = this.assignees.length - 1;

        this.itemIndex = index % this.assignees.length;
        this.selectedElement = this.assignees[this.itemIndex];
        this.focusInput();
        break;

      case 9: // Tab
        // Ignore
        break;
    }
  }

  trackByAssigneeId(index: number, assignee: any): any {
    return assignee?.id ?? assignee;
  }
}
